import DonutChart, { DonutChartData } from "@/components/visualizations/DonutChart/DonutChart";
import useTranslation from "@/hooks/useTranslation";
import { useProductImpactTotals } from "@/pages/dashboard/hooks/useProductImpact";
import { formatLifecycleLabel } from "@/pages/dashboard/utils/formatters";
import Widget from "../../components/Widget/Widget";
import { ImpactMetric } from "../../utils/types";

export default function ProductImpactPerLifecycle({ metric }: { metric: ImpactMetric }) {
  const translation = useTranslation();
  const { data, isLoading, isFetching } = useProductImpactTotals({ metrics: [metric.key] });

  const chartData: DonutChartData =
    data?.data && data.data.length > 0
      ? data.data.map((row) => ({
          label: formatLifecycleLabel(row.label),
          value: row.impact[metric.key],
        }))
      : [];

  return (
    <Widget
      title={"Product impact per life cycle phase"}
      tooltip={translation["dashboard"]["product"]["per_life_cycle_phase"]}
    >
      <DonutChart
        colorPalette="forest_green"
        data={chartData}
        format={metric.formatter}
        loading={isLoading || isFetching}
      />
    </Widget>
  );
}
